export default "__VITE_ASSET__Dg8xQUjl__"